<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Profile',
    path: '/profile',
    active: true
}]">
</app-breadcrumb>
<div class="row">
    <div class="col-6">
        <div class="row">
            <div class="col-6">
                <app-page-content>
                    First Name
                    <dx-text-box [(value)]="currentUser.firstName"></dx-text-box>
                </app-page-content>
            </div>
            <div class="col-6">
                <app-page-content>
                    Last Name
                    <dx-text-box [(value)]="currentUser.lastName"></dx-text-box>
                </app-page-content>
            </div>
        </div>
        <app-page-content>
            Phone
            <dx-text-box [(value)]="currentUser.phone"></dx-text-box>
        </app-page-content>
        <app-page-content>
            Email
            <dx-text-box [(value)]="currentUser.email" [disabled]="true"></dx-text-box>
        </app-page-content>
        <app-page-content class="text-center">
            <dx-button text="Save" type="success" (onClick)="saveProfile()"></dx-button>
        </app-page-content>
    </div>
    <div class="col-6">
        <app-page-content>
            Current Password
            <dx-text-box [(value)]="currentPassword" [mode]="'password'"></dx-text-box>
        </app-page-content>
        <app-page-content>
            New Password
            <dx-text-box [(value)]="newPassword"></dx-text-box>
        </app-page-content>
        <app-page-content>
            Confirm New Password
            <dx-text-box [(value)]="confirmNewPassword"></dx-text-box>
        </app-page-content>
        <app-page-content class="text-center">
            <dx-button text="Reset Password" type="success" (onClick)="resetPassword()"></dx-button>
        </app-page-content>
    </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>